export default {
	'generic-error': 'There has been an error. Please retry',
	'qty-size-mandatory': 'Quantity and size are mandatory',
	'add-to-cart-success': 'Product successfully added to cart',
	'add-to-cart-error': 'There was an error adding the product to the cart, please try again',
	'remove-from-cart-success': 'Product successfully removed from cart',
	'remove-from-cart-error': 'There was an error removing the product from the cart, please try again',
	'review-success': 'Thank you for submitting your review',
	'review-error': 'There was an error submitting your review, please try again',
}
